import { Poll, RetrievePollPayload } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

import { POLL_BY_ID } from "~/constants/react-query-keys/poll";

import { usePollApi } from "./usePollApi";

export interface PollUser {
  id: number;
  given_name: string;
  family_name: string;
  username: string;
  image: string;
}

export interface PollResponseData {
  no: number;
  yes: number;
  votes: {
    no: PollUser[];
    yes: PollUser[];
  };
  poll: Poll;
}

export default function useChatConversationPoll(
  id: number,
  members: RetrievePollPayload,
  options?: UseQueryOptions<PollResponseData>
) {
  const api = usePollApi();
  return useQuery({
    queryKey: [POLL_BY_ID, id, members],
    queryFn: async () => {
      const { data } = await api.retrievePollByConversationId(id, members);
      return data;
    },
    ...options,
  });
}
